<template>
  <nav class="menu-container">
    深圳地铁线路
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title}}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1",
          // icon: "chat",
          exact: true,
        },
        {
          name: "erhaoxian",
          title: "2",
          // icon: "chat",
          exact: true,
        },
        {
          name: "sanhaoxian",
          title: "3",
          // icon: "chat",
          exact: true,
        },
        {
          name: "sihaoxian",
          title: "4",
          // icon: "chat",
          exact: true,
        },
        {
          name: "wuhaoxian",
          title: "5",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liuhaoxian",
          title: "6",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liuhaoxianzhixian",
          title: "6号线支线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7",
          // icon: "chat",
          exact: true,
        },
        {
          name: "bahaoxian",
          title: "8",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jiuhaoxian",
          title: "9",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shihaoxian",
          title: "10",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiyihaoxian",
          title: "11",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shierhaoxian",
          title: "12",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shisihaoxian",
          title: "14",
          // icon: "chat",
          exact: true,
        },
        {
        name: "shiliuhaoxian",
          title: "16",
          // icon: "chat",
          exact: true,
        },
        {
          name: "ershihaoxian",
          title: "20",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>



<!-- <template>
  <h4>地铁
    <!!--A6--><a href=ditie.html>地铁线路</a><br>
<!--A7--><a href="/yihaoxian">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=009943>1</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font>
<!--A8--><a href="2.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=915028>2</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font>
<!--A9--><a href="3.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=0087d2>3</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font>
<!--A10--><a href="4.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=be0f19>4</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font><br>
<!--A11--><a href="5.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=824b82>5</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font>
<!--A12--><a href="6.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=02c8b9>6</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font><a href="7.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=0a3282>7</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font>
<!--A13--><a href="8.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=915026>8</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font><br>
<!--A14--><a href="9.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=82646e>9</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font>
<!--A15--><a href="10.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=f97c9c>10</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font>
<!--A16--><a href="11.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=641937>11</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font>
<!--A16-2--><a href="12.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=purple>12</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font><br>
<!--A17--><a href="14.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=#ffbf00>14</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font>
<!--A18--><a href="20.html">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size=6 color=4b9490>20</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><font color=grey>|</font><br><hr>
  </h4>
</template>

<script>
export default {};
</script>

<style></style> -->
